import React, { useState } from 'react';
import { CalendarIcon, DollarSignIcon, GlobeIcon, TagIcon, MapPinIcon } from 'lucide-react';
interface AdvancedSearchProps {
  filters: {
    countries: string[];
    sectors: string[];
    budgetMin: string;
    budgetMax: string;
    dateRange: any;
  };
  onFilterChange: (filters: any) => void;
}
export function AdvancedSearch({
  filters,
  onFilterChange
}: AdvancedSearchProps) {
  // Mock data for countries and sectors
  const availableCountries = ['Sénégal', 'Maroc', "Côte d'Ivoire", 'Tunisie', 'Algérie', 'Kenya', 'Égypte', 'Ghana', 'Cameroun', 'Afrique du Sud'];
  const availableSectors = ['Agriculture', 'Construction', 'Éducation', 'Énergie', 'Environnement', 'Finance', 'Santé', 'Infrastructure', 'Technologies', 'Transport'];
  const [budgetMin, setBudgetMin] = useState(filters.budgetMin);
  const [budgetMax, setBudgetMax] = useState(filters.budgetMax);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const handleCountryToggle = (country: string) => {
    const isSelected = filters.countries.includes(country);
    let newCountries;
    if (isSelected) {
      newCountries = filters.countries.filter(c => c !== country);
    } else {
      newCountries = [...filters.countries, country];
    }
    onFilterChange({
      countries: newCountries
    });
  };
  const handleSectorToggle = (sector: string) => {
    const isSelected = filters.sectors.includes(sector);
    let newSectors;
    if (isSelected) {
      newSectors = filters.sectors.filter(s => s !== sector);
    } else {
      newSectors = [...filters.sectors, sector];
    }
    onFilterChange({
      sectors: newSectors
    });
  };
  const handleBudgetApply = () => {
    onFilterChange({
      budgetMin,
      budgetMax
    });
  };
  const handleDateApply = () => {
    if (startDate && endDate) {
      onFilterChange({
        dateRange: {
          start: startDate,
          end: endDate
        }
      });
    }
  };
  return <div className="border-t border-gray-200 px-6 py-4 bg-gray-50" data-id="element-638">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-639">
        {/* Countries filter */}
        <div data-id="element-640">
          <div className="flex items-center mb-3" data-id="element-641">
            <GlobeIcon size={18} className="text-gray-500 mr-2" data-id="element-642" />
            <h3 className="text-sm font-medium text-gray-700" data-id="element-643">Pays</h3>
          </div>
          <div className="space-y-2 max-h-48 overflow-y-auto pr-2" data-id="element-644">
            {availableCountries.map(country => <div key={country} className="flex items-center" data-id="element-645">
                <input id={`country-${country}`} name={`country-${country}`} type="checkbox" checked={filters.countries.includes(country)} onChange={() => handleCountryToggle(country)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-646" />
                <label htmlFor={`country-${country}`} className="ml-2 text-sm text-gray-700" data-id="element-647">
                  {country}
                </label>
              </div>)}
          </div>
        </div>
        {/* Sectors filter */}
        <div data-id="element-648">
          <div className="flex items-center mb-3" data-id="element-649">
            <TagIcon size={18} className="text-gray-500 mr-2" data-id="element-650" />
            <h3 className="text-sm font-medium text-gray-700" data-id="element-651">Secteurs</h3>
          </div>
          <div className="space-y-2 max-h-48 overflow-y-auto pr-2" data-id="element-652">
            {availableSectors.map(sector => <div key={sector} className="flex items-center" data-id="element-653">
                <input id={`sector-${sector}`} name={`sector-${sector}`} type="checkbox" checked={filters.sectors.includes(sector)} onChange={() => handleSectorToggle(sector)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-654" />
                <label htmlFor={`sector-${sector}`} className="ml-2 text-sm text-gray-700" data-id="element-655">
                  {sector}
                </label>
              </div>)}
          </div>
        </div>
        {/* Budget filter */}
        <div data-id="element-656">
          <div className="flex items-center mb-3" data-id="element-657">
            <DollarSignIcon size={18} className="text-gray-500 mr-2" data-id="element-658" />
            <h3 className="text-sm font-medium text-gray-700" data-id="element-659">Budget (€)</h3>
          </div>
          <div className="space-y-3" data-id="element-660">
            <div data-id="element-661">
              <label htmlFor="budget-min" className="block text-xs text-gray-500 mb-1" data-id="element-662">
                Montant minimum
              </label>
              <input type="number" id="budget-min" value={budgetMin} onChange={e => setBudgetMin(e.target.value)} placeholder="Min" className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-663" />
            </div>
            <div data-id="element-664">
              <label htmlFor="budget-max" className="block text-xs text-gray-500 mb-1" data-id="element-665">
                Montant maximum
              </label>
              <input type="number" id="budget-max" value={budgetMax} onChange={e => setBudgetMax(e.target.value)} placeholder="Max" className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-666" />
            </div>
            <button onClick={handleBudgetApply} className="w-full inline-flex justify-center items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-667">
              Appliquer
            </button>
          </div>
        </div>
        {/* Date filter */}
        <div data-id="element-668">
          <div className="flex items-center mb-3" data-id="element-669">
            <CalendarIcon size={18} className="text-gray-500 mr-2" data-id="element-670" />
            <h3 className="text-sm font-medium text-gray-700" data-id="element-671">
              Date de publication
            </h3>
          </div>
          <div className="space-y-3" data-id="element-672">
            <div data-id="element-673">
              <label htmlFor="date-start" className="block text-xs text-gray-500 mb-1" data-id="element-674">
                Date de début
              </label>
              <input type="date" id="date-start" value={startDate} onChange={e => setStartDate(e.target.value)} className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-675" />
            </div>
            <div data-id="element-676">
              <label htmlFor="date-end" className="block text-xs text-gray-500 mb-1" data-id="element-677">
                Date de fin
              </label>
              <input type="date" id="date-end" value={endDate} onChange={e => setEndDate(e.target.value)} className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-678" />
            </div>
            <button onClick={handleDateApply} className="w-full inline-flex justify-center items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-679">
              Appliquer
            </button>
          </div>
        </div>
      </div>
      {/* Additional filters section */}
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-680">
        <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-681">
          Filtres supplémentaires
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-682">
          <div className="flex items-center" data-id="element-683">
            <input id="filter-published" name="filter-published" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-684" />
            <label htmlFor="filter-published" className="ml-2 text-sm text-gray-700" data-id="element-685">
              Uniquement les appels publiés
            </label>
          </div>
          <div className="flex items-center" data-id="element-686">
            <input id="filter-deadline" name="filter-deadline" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-687" />
            <label htmlFor="filter-deadline" className="ml-2 text-sm text-gray-700" data-id="element-688">
              Délai de soumission &gt; 30 jours
            </label>
          </div>
          <div className="flex items-center" data-id="element-689">
            <input id="filter-international" name="filter-international" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-690" />
            <label htmlFor="filter-international" className="ml-2 text-sm text-gray-700" data-id="element-691">
              Financements internationaux
            </label>
          </div>
          <div className="flex items-center" data-id="element-692">
            <input id="filter-documents" name="filter-documents" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-693" />
            <label htmlFor="filter-documents" className="ml-2 text-sm text-gray-700" data-id="element-694">
              Avec documents téléchargeables
            </label>
          </div>
        </div>
      </div>
    </div>;
}